<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">About Info</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">About</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">About Info</h6>
            </div>
            <div>
              <ValidationObserver ref="addAboutForm" id="addAboutForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs v-if="formData.type === 'text'" content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider rules="required" v-slot="{ classes }" tag="div" class="form-group">
                      <label :for="'value[' + language.code + ']'" class="form-label">Value:</label>
                      <input :id="'value[' + language.code + ']'" :dir="language.type" class="form-control" :name="'value[' + language.code + ']'" v-model="formData.value[language.code]" :class="checkValidation(classes)" placeholder="value" type="text">
                    </ValidationProvider>
                  </b-tab>
                </b-tabs>
                <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                  <label for="kay" class="form-label">Key:</label>
                  <input id="kay" class="form-control" name="key" v-model="formData.key" :class="checkValidation(classes)" placeholder="kay" type="text">
                </ValidationProvider>
                <ValidationProvider v-if="!isEdit" v-slot="{ classes }" rules="required" tag="div" class="form-group">
                  <label for="categories" class="form-label">Categories:</label>
                  <select id="categories" class="form-control" name="type" v-model="formData.type" :class="checkValidation(classes)" type="text">
                    <option value="text">text</option>
                    <option value="image">image</option>
                  </select>
                </ValidationProvider>
                <input v-else type="hidden" name="type" :value="formData.type">
                <div v-if="formData.type === 'image'">
                    <img width="150" :src="formData.value" alt="">
                    <ImageUpload accept="image/png,image/jpeg,image/jpg" label="Image:" name="value" uploadType="oneImage" type="image" :validation="true" :filesData="[formData.value]" />
                  </div>
                <button class="btn ripple btn-main-primary" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageUpload from '../../components/ImageUpload'

export default {
  name: 'AddNews',
  data () {
    return {
      buttonDisable: false,
      formData: {
        type: 'text',
        kay: '',
        value: {}
      },
      uploadedVideoFile: {},
      videoType: 'video_iframe',
      serviceInfoId: null,
      categories: null,
      letterCount: '',
      wordCount: ''
    }
  },
  components: {
    ImageUpload
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages
    })
  },
  created () {
    if (this.$route.params.id === 'add') {
      this.isEdit = false
    } else {
      this.isEdit = true
      this.formData.type = 'image'
      this.getSetting(this.$route.params.id).then(res => {
        console.log(res)
        this.formData = res
      })
    }
  },
  methods: {
    ...mapActions({
      getSetting: 'about/getSetting',
      createSettings: 'about/createSettings',
      updateSettingsImage: 'about/updateSettingsImage'
    }),
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.addAboutForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          const form = document.getElementById('addAboutForm')
          const formData = new FormData(form)
          if (this.$route.params.id === 'add') {
            this.createSettings({ data: formData }).then(res => {
              this.$toasted.success(this.$t('messages.success.newsUpdated')).goAway(1500)
              this.$router.push('/about')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            console.log(formData.get('value'))
            this.updateSettingsImage({ data: formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.newsUpdated')).goAway(1500)
              this.$router.push('/about')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    },
    uploadCoverFile (file) {
      const uploadFile = file[0]
      this.uploadedVideoFile = uploadFile
    }
  }
}
</script>
